export default "__VITE_ASSET__9y8lgrQQ__"